import { lazy, Suspense } from 'react';
import type { SpendingChartProps } from './spending-chart.js';
import styles from './spending-chart.module.css';

const LoadedSpendingChart = lazy(async () => {
  const chartModule = await import('./spending-chart.js');
  return { default: chartModule.SpendingChart };
});

export const LazySpendingChart = (props: SpendingChartProps) => (
  <Suspense fallback={<div className={styles.chart} />}>
    <LoadedSpendingChart {...props} />
  </Suspense>
);
